import * as signInStyles from './SignIn.styles';

import Auth from '../Auth';
import AuthPrompt from '../AuthPrompt';
import PageTitle from '../PageTitle';
import trackRegistrationRefer from '../../utils/tracking/refererTracking';
import useQueryString from '../../hooks/useQueryString';
import { PublicRoutePath } from '../../utils/routes';
import { TrackingEventSource } from '../../utils/tracking/types';
import { authenticated$ } from '../../store/session/selectors';
import { getBrandContent } from '../../store/features/brandingContent';
import PageHead from '../PageHead';

import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import Container from '@mui/material/Container';

function SignIn() {
  const redirect = useQueryString('redirect');

  const { classes } = signInStyles.useStyles();
  const { classes: containerClasses } = signInStyles.useContainerStyles();

  const authenticated = useSelector(authenticated$);
  const brandingContent = getBrandContent();

  const { push } = useRouter();

  useEffect(() => {
    if (authenticated) void push(PublicRoutePath.HOME);
  }, [authenticated, push]);

  const handleClick = () => {
    trackRegistrationRefer(TrackingEventSource.SIGN_IN_PAGE);
  };

  return (
    <>
      <PageHead title="SIGNIN" />

      <Container disableGutters classes={classes}>
        <PageTitle>Sign-in to your account</PageTitle>

        <AuthPrompt
          onClick={handleClick}
          link={PublicRoutePath.SIGNUP}
          text="Not a customer yet?"
          buttonText={brandingContent.signUpButton}
        />
        <div className={containerClasses.root}>
          <Auth source={TrackingEventSource.SIGN_IN_PAGE} redirect={redirect || PublicRoutePath.HOME} />
        </div>
      </Container>
    </>
  );
}

export default SignIn;
